import {Avatar} from '../../../shared/components/avatar';
import {Confetti} from '../../../shared/components/confetti';
import {Stamp} from '../../../shared/sticker/stickers';

// Confetti sits behind the text here, so it never covers the heading.
export const ThanksSplash = ({
    name,
    photoUrl,
    celebrate,
}: {
    name: string;
    photoUrl: string | null;
    celebrate: boolean;
}) => (
    <main className="ph-page ph-thanks">
        {celebrate && (
            <div className="sd-confetti ph-thanks__confetti" aria-hidden="true">
                <Confetti count={90} />
            </div>
        )}
        <div className="ph-stack ph-center ph-fill ph-thanks__body">
            <Avatar src={photoUrl ?? undefined} name={name} size={72} />
            <h1 className="ph-title">Thanks for your vote, {name}!</h1>
            <p className="ph-muted ph-thanks__sub">Eyes on the big screen for the results.</p>
            <span className="ph-thanks__stamp">
                <Stamp>VOTED</Stamp>
            </span>
        </div>
    </main>
);
